const CONSENT_VALIDITY_PERIOD_MS = 6 * 30 * 24 * 60 * 60 * 1000;

/**
 * Checks if a consent date is within the validity period
 */
export function isConsentValid(
  consentedAt: string | null | undefined,
): boolean {
  if (!consentedAt) return false;
  const date = new Date(consentedAt);
  return Date.now() - date.getTime() < CONSENT_VALIDITY_PERIOD_MS;
}
